import { analyticsUtils } from 'utils/analytics-utils';

export const gaClickCalculateLaminate = ({ cost }: { cost: string }) =>
  analyticsUtils.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock: 'productDetail / calc',
    elementName: cost,
    elementText: 'Рассчитать',
  });
